module.exports = __webpack_public_path__ + "static/media/icon-trello.732cf32a.svg";